module.exports = __webpack_public_path__ + "img/quanyi3_icon.8de6cad8.svg";